import { type LensListItemModel } from "../../lenses/models";
import { type CreateGroupV2MutationVariables } from "../api/mutations/createGroupV2.gql-generated";

export interface NewGroup {
    name: string;
    lenses: readonly LensListItemModel[];
}

export function toMutationVariables({ name }: NewGroup): CreateGroupV2MutationVariables {
    return {
        name,
    };
}
